"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavHorizontalItemComponent = /** @class */ (function () {
    function FuseNavHorizontalItemComponent() {
        this.classes = 'nav-item';
    }
    return FuseNavHorizontalItemComponent;
}());
exports.FuseNavHorizontalItemComponent = FuseNavHorizontalItemComponent;
